import React from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PLATFORM_CONSOLE_PATH, PLATFORM_CONSOLE_BASE } from "./platformConsoleRoutes";
import { PLATFORM_CONSOLE_SECTION_ORDER, usePlatformConsoleAcl } from "./PlatformConsoleAclContext";

function firstNavigableSectionPath(can) {
  for (const key of PLATFORM_CONSOLE_SECTION_ORDER) {
    if (can(key, "view")) return PLATFORM_CONSOLE_PATH[key];
  }
  return "/settings/billing";
}

/**
 * Bloqueia rota do console quando o master não tem permissão de leitura na seção.
 */
export default function PlatformConsoleSectionGate({ section, children }) {
  const { t } = useTranslation("app");
  const { loading, can } = usePlatformConsoleAcl();

  if (loading) {
    return (
      <Box sx={{ py: 6, display: "flex", justifyContent: "center" }} role="status" aria-live="polite">
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!can(section, "view")) {
    const fallback = firstNavigableSectionPath(can);
    if (fallback.startsWith(PLATFORM_CONSOLE_BASE)) {
      return (
        <Box sx={{ py: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            {t("platformPage.sectionAccessDenied")}
          </Alert>
          <Navigate to={fallback} replace />
        </Box>
      );
    }
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {t("platformPage.sectionAccessDeniedBilling")}
        </Alert>
        <Navigate to={fallback} replace />
      </Box>
    );
  }

  return children;
}
